import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Close } from "@mui/icons-material";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  title: string;
  children: React.ReactNode;
}

function CustomDialog({
  open,
  onClose,
  onConfirm,
  confirmText,
  cancelText,
  title,
  children,
}: Props): JSX.Element {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        <MDBox display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5">{title}</MDTypography>
          <MDButton onClick={onClose} color="error" variant="outlined">
            <Close />
          </MDButton>
        </MDBox>
      </DialogTitle>
      <DialogContent sx={{ padding: "16px" }}>
        <MDBox mt={2}>{children}</MDBox>
      </DialogContent>
      <DialogActions>
        {onConfirm && (
          <MDButton onClick={onConfirm} color="primary" variant="contained">
            {confirmText ? confirmText : "Confirm"}
          </MDButton>
        )}
        {onClose && (
          <MDButton onClick={onClose} color="error" variant="contained">
            {cancelText ? cancelText : "Close"}
          </MDButton>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default CustomDialog;
